/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import QRCode from "qrcode.react";

import * as controlPanelActions from "../../../actions/controlPanelActions";
import { getDevices } from "../../../helpers/appetize/getDevices";

class GlobalPreview extends Component {
	constructor(props) {
		super(props);
		var defaultState = localStorage.getItem("globalPreview");
		let value = 0;
		let iosVersion = "";
		let androidVersion = "12.0";
		let supportedDevices = [];

		if (defaultState) {
			let object = JSON.parse(defaultState);
			if (object.value) {
				value = object.value;
			}
			if (object.iosVersion) {
				iosVersion = object.iosVersion;
			}
			if (object.androidVersion) {
				androidVersion = object.androidVersion;
			}
		}
		this.state = {
			value,
			rotation: "up",
			device: "iphone14pro",
			iosVersion,
			androidVersion,
			appetizeParams: encodeURIComponent(
				`{
  				"isAppPreview": true,
  				"appId": "${props.appKey}"
				}`
			),
			showPreviewCode: false,
			supportedDevices,
		};
	}

	componentDidMount = async () => {
		const devices = await getDevices();
		this.setState({ supportedDevices: devices, iosVersion: devices[this.state.value].supportedOS[0] });
	};

	rotateCounterClockwise = () => {
		if (this.iframe) {
			this.iframe.contentWindow.postMessage("rotateLeft", "*");
		}
	};

	rotateClockwise = () => {
		if (this.iframe) {
			this.iframe.contentWindow.postMessage("rotateRight", "*");
		}
	};

	setDevice = value => {
		const device = this.state.supportedDevices[value];
		const osVersion = device.supportedOS[0];
		localStorage.setItem(
			"globalPreview",
			JSON.stringify({
				value: value,
				[device.os === "ios" ? "iosVersion" : "androidVersion"]: osVersion,
			})
		);
		this.setState({
			value: parseInt(value, 10),
			[device.os === "ios" ? "iosVersion" : "androidVersion"]: osVersion,
		});
	};

	setIosVersion = value => {
		localStorage.setItem(
			"globalPreview",
			JSON.stringify({ value: this.state.value, iosVersion: value, androidVersion: this.state.androidVersion })
		);
		this.setState({ iosVersion: value });
	};

	setAndroidVersion = value => {
		localStorage.setItem(
			"globalPreview",
			JSON.stringify({ value: this.state.value, iosVersion: this.state.iosVersion, androidVersion: value })
		);
		this.setState({ androidVersion: value });
	};

	render() {
		const { showPreviewCode } = this.state;
		const {
			controlPanelActions,
			responsive: { isResponsive },
		} = this.props;

		//iphone4s, iphone5s, iphone6, iphone6plus, ipadair, iphone6s, iphone6splus, ipadair2, nexus5, nexus7 or nexus9

		let device = this.state.supportedDevices[this.state.value];

		if (device) {
			return (
				<React.Fragment>
					{showPreviewCode ? (
						<div className="absolute-center">
							<div className="m-bottom ta-center">
								<QRCode value={this.props.appKey} fgColor="#292FC1" size={80} />
							</div>
							<h4 className="title">Preview On Your Device</h4>
							<h6 className="ta-center" style={{ lineHeight: "1.6em" }}>
								Download the Event App from the App Store or Google Play store, then scan this QR Code
								to get started
							</h6>
							<div
								className="btn wide btn-primary m-top"
								onClick={() => this.setState({ showPreviewCode: false })}
							>
								Go Back
							</div>
						</div>
					) : (
						<React.Fragment>
							{isResponsive ? (
								<div
									className="btn wide btn-primary m-bottom"
									onClick={controlPanelActions.toggleAppPreview}
								>
									Close
								</div>
							) : (
								<div
									className="btn wide btn-primary m-bottom"
									onClick={() => this.setState({ showPreviewCode: true })}
								>
									Preview On Your Own Device
								</div>
							)}
							<div className="global-preview-controls m-bottom">
								<div
									className="global-preview-control btn btn-primary"
									onClick={this.rotateCounterClockwise}
								>
									<i className="fal fa-undo"></i>
								</div>
								<div className="global-preview-select">
									<i className="fal fa-chevron-down"></i>
									<select value={this.state.value} onChange={e => this.setDevice(e.target.value)}>
										<optgroup label="iPhones">
											{this.state.supportedDevices.map((value, index) => {
												return (
													value.type === "iphone" && (
														<option key={index} value={index}>
															{value.label}
														</option>
													)
												);
											})}
										</optgroup>
										<optgroup label="iPads">
											{this.state.supportedDevices.map((value, index) => {
												return (
													value.type === "ipad" && (
														<option key={index} value={index}>
															{value.label}
														</option>
													)
												);
											})}
										</optgroup>
									</select>
								</div>
								{device.os === "ios" && (
									<div className="global-preview-select">
										<i className="fal fa-chevron-down"></i>
										<select
											value={this.state.iosVersion}
											onChange={e => this.setIosVersion(e.target.value)}
										>
											{device.supportedOS.map(value => (
												<option key={value} value={value}>
													{value}
												</option>
											))}
										</select>
									</div>
								)}
								<div
									className="global-preview-control btn btn-primary m-left"
									onClick={this.rotateClockwise}
								>
									<i className="fal fa-redo"></i>
								</div>
							</div>
							<iframe
								ref={r => {
									this.iframe = r;
								}}
								targetorigin="apoc://"
								src={`https://appetize.io/embed/${device.appetizeKey}?device=${device.device}&scale=${
									device.scale
								}&osVersion=${
									device.os === "ios" ? this.state.iosVersion : this.state.androidVersion
								}&autoplay=true&centered=true&orientation=portrait&deviceColor=black&xdocMsg=true&params=${
									this.state.appetizeParams
								}`}
								width="100%"
								height={`${device.height}px`}
								frameBorder="0"
								scrolling="no"
								title="Your App Preview"
							/>
						</React.Fragment>
					)}
				</React.Fragment>
			);
		} else {
			return <p>Loading</p>;
		}
	}
}

GlobalPreview.propTypes = {
	appKey: PropTypes.string,
};

const mapStateToProps = state => ({
	errors: state.validation.errors,
	responsive: state.responsive,
});

const mapDispatchToProps = dispatch => ({
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(GlobalPreview);
